interface AwardBadgeProps {
  awardType: 'monthly' | 'annual';
  category: 'checkin' | 'spot';
  rank: number;
  year: number;
  month: number | null;
}

const RANK_COLORS = {
  1: { bg: 'bg-yellow-400', border: 'border-yellow-500', text: 'text-yellow-900' },
  2: { bg: 'bg-gray-300', border: 'border-gray-400', text: 'text-gray-800' },
  3: { bg: 'bg-amber-600', border: 'border-amber-700', text: 'text-amber-50' },
} as const;

const CATEGORY_LABELS: Record<string, string> = {
  checkin: 'チェックイン',
  spot: 'スポット',
};

function getRankLabel(awardType: 'monthly' | 'annual', rank: number): string {
  if (awardType === 'annual') {
    if (rank === 1) return 'MVP';
    if (rank === 2) return '準MVP';
    return '第3位';
  }
  // monthly
  if (rank === 1) return 'No.1';
  if (rank === 2) return 'No.2';
  return 'No.3';
}

function getPeriodLabel(
  awardType: 'monthly' | 'annual',
  year: number,
  month: number | null
): string {
  if (awardType === 'monthly' && month !== null) {
    return `${year}年${month}月`;
  }
  return `${year}年`;
}

export function AwardBadge({ awardType, category, rank, year, month }: AwardBadgeProps) {
  const colors = RANK_COLORS[rank as 1 | 2 | 3] ?? RANK_COLORS[3];
  const rankLabel = getRankLabel(awardType, rank);
  const periodLabel = getPeriodLabel(awardType, year, month);
  const categoryLabel = CATEGORY_LABELS[category] ?? category;
  const isAnnual = awardType === 'annual';

  return (
    <div
      className={`inline-flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-lg border-2 ${colors.bg} ${colors.border} ${isAnnual ? 'min-w-[80px]' : 'min-w-[72px]'}`}
    >
      <span className={`text-xs font-bold ${colors.text} leading-tight`}>{rankLabel}</span>
      <span
        className={`text-[10px] font-medium ${colors.text} opacity-90 leading-tight text-center`}
      >
        {categoryLabel}
      </span>
      <span className={`text-[9px] ${colors.text} opacity-75 leading-tight`}>{periodLabel}</span>
      {isAnnual && (
        <span className={`text-[9px] font-bold ${colors.text} uppercase tracking-wide`}>
          ANNUAL
        </span>
      )}
    </div>
  );
}
